import { Link } from 'react-router-dom';
import { genres } from '@/mocks/movies';

export default function CategoryGrid() {
  return (
    <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-8">
      {genres.map((genre) => (
        <Link
          key={genre.name}
          to={`/movies?genre=${encodeURIComponent(genre.name)}`}
          className="group flex flex-col gap-3 rounded-lg border border-background-200 bg-background-100 p-4 transition-colors hover:border-primary-500/60 hover:bg-background-200/70"
        >
          <span className="flex h-9 w-9 items-center justify-center rounded-md bg-primary-500/10 text-primary-500 transition-colors group-hover:bg-primary-500 group-hover:text-background-50">
            <i className={`${genre.icon} text-lg`} aria-hidden="true"></i>
          </span>
          <div>
            <p className="text-sm font-medium text-foreground-900">{genre.name}</p>
            <p className="mt-1 hidden text-[11px] leading-5 text-foreground-500 sm:block">{genre.desc}</p>
          </div>
        </Link>
      ))}
    </div>
  );
}